import { ChevronDownIcon, ChevronUpIcon } from "@radix-ui/react-icons";
import * as Select from "@radix-ui/react-select";
const provinces = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
];
type ProvinceSelectorProps = {
  province: string | undefined;
  onSelectProvince: (province: string) => void;
};
export const ProvinceSelector = ({
  province,
  onSelectProvince,
}: ProvinceSelectorProps) => {
  return (
    <Select.Root
      value={province}
      onValueChange={(value) => {
        onSelectProvince(value as string);
      }}
      data-testid="form-provinceselector"
    >
      <Select.Trigger
        type="button"
        className="text-pebble dark:text-snow py-2 h-full w-full inline-flex items-end gap-[5px] min-w-[150px] justify-between data-[placeholder]:text-gray-400 dark:data-[placeholder]:text-gray-400 outline-none border-b-rock border-b-2"
        data-testid="form-provinceselector"
      >
        <div className="relative top-[4px] flex w-full justify-between">
          <Select.Value
            placeholder="Select province"
            data-testid="form-provinceselector"
          />
        </div>
        <Select.Icon className="" data-testid="form-provinceselector">
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className="bg-white dark:bg-pebble overflow-hidden border border-pebble dark:border-white"
          data-testid="form-provinceselector"
        >
          <Select.ScrollUpButton
            className="p-2.5"
            data-testid="form-provinceselector"
          >
            <ChevronUpIcon />
          </Select.ScrollUpButton>
          <Select.Viewport data-testid="form-provinceselector">
            {provinces.map((province) => {
              return (
                <Select.Item
                  key={province}
                  value={province}
                  className="hover:bg-rock min-w-[150px] justify-between p-2 cursor-pointer"
                  data-testid={`province-selector-item-${province}`}
                >
                  <Select.ItemText
                    data-testid={`province-selector-item-text-${province}`}
                  >
                    {province}
                  </Select.ItemText>
                </Select.Item>
              );
            })}
          </Select.Viewport>
          <Select.ScrollDownButton
            className="p-2.5"
            data-testid="form-provinceselector"
          >
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};
{
  /* <Select.Root
          name="provinces"
          value={address.province}
          onValueChange={(val) => setProvince(val)}
        >
          <Select.Trigger
            className="p-2.5 inline-flex items-center gap-1 min-w-[150px] justify-between"
            aria-label="Token"
          >
            <Select.Value placeholder="Province" />
            <Select.Icon>
              <ChevronDownIcon />
            </Select.Icon>
          </Select.Trigger>
          <Select.Portal>
            <Select.Content
              position="popper"
              className="bg-white dark:bg-pebble overflow-hidden"
            >
              <Select.Viewport>
                <Select.ScrollUpButton className="flex items-center justify-center h-[25px] bg-white text-violet11 cursor-default">
                  <ChevronUpIcon />
                </Select.ScrollUpButton>
                {provinces.map((province) => {
                  return (
                    <Select.Item
                      className="hover:bg-rock min-w-[150px] justify-between p-2"
                      value={province}
                      key={province}
                    >
                      {province}
                    </Select.Item>
                  );
                })}
                <Select.ScrollDownButton className="flex items-center justify-center h-[25px] bg-white cursor-default">
                  <ChevronDownIcon />
                </Select.ScrollDownButton>
              </Select.Viewport>
            </Select.Content>
          </Select.Portal>
        </Select.Root> */
}

/* 
Potential improvements:
1. Add aria-labels for better accessibility
2. Add keyboard navigation improvements
3. Consider a more descriptive dropdown placeholder (e.g., "Select your province")
4. Include full province names alongside abbreviations for better usability
5. Add loading state for async data fetching scenarios
6. Consider adding validation or error state styling
7. Improve mobile touch target sizes
*/
